import React from 'react';
import ProductImage from 'components/Image/ProductImage';
import type { Option } from 'types';
import { SelectMenu } from 'components/SelectMenu';
import styles from './ListItem.module.scss';

interface Props {
  showImage: boolean;
  imageUri?: string | null;
  name: string;
  availabilityType: string;
  isLoading?: boolean;
  titleWithBoldSearchText: JSX.Element | string;
  minPrice: string;
  maxPrice: string;
  appPriceList: Option[];
  itemHasSurcharge: boolean;
  mmId: string;
}

const ItemImageAndTitle: React.FC<Props> = React.memo(
  ({
    showImage,
    imageUri,
    name,
    availabilityType,
    isLoading,
    titleWithBoldSearchText,
    minPrice,
    maxPrice,
    appPriceList,
    itemHasSurcharge,
    mmId
  }) => (
    <>
      {showImage && (
        <ProductImage
          src={imageUri || '/Images/NoImage.svg'}
          alt={`Thumbnail for ${name}`}
          className={`${availabilityType === 'unavailable' ? styles.GhostIcon : ''}`}
          testId={`list-item-thumbnail-${mmId}`}
          isLoading={isLoading}
        />
      )}
      <div>
        <p className={isLoading ? 'LoadingCoverText' : ''} data-testid="list-item-title">
          {titleWithBoldSearchText}
        </p>
        <div className={styles.PriceRangeMobile}>
          <SelectMenu
            options={minPrice === maxPrice ? [] : appPriceList}
            defaultButtonContent={
              <span>
                {itemHasSurcharge && (
                  <div className={styles.Surcharge}>
                    <span data-testid="list-item-surcharge">%</span>
                  </div>
                )}
                {minPrice === maxPrice ? minPrice : `${minPrice} - ${maxPrice}`}
              </span>
            }
            buttonStyle={`${styles.Price} ${isLoading ? 'LoadingCoverText' : ''}`}
            questionMark={!isLoading}
            downIcon={null}
            align="center"
            size="small"
            disabled
          />
        </div>
      </div>
    </>
  )
);

export default ItemImageAndTitle;
